<template>
  <div>
    <ClientPreferences
      v-if="context.advisor_id"
      :context="context"
      :prospect="prospect"
      :vadisNonEmbed="vadisNonEmbed"
    />
  </div>
</template>


<script>
import ClientPreferences from '@frontend/dash3/js/widgets/ClientPreferences.vue';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

/*
context.
  advisor_id
  client_id (prospect external id)
  prospect
  firm_screen_sets
  default_screen_sets
*/

export default {
  components: { ClientPreferences },
  props: [/* Inputs */],
  data() {
    return {
      headers: null,
      advisorSlug: null,
      vuid: null,
      context: {},
      prospectID: null,
      prospect: null,
      vadisNonEmbed: false,
    };
  },
  watch: {
    prospectID() {
      this.getProspect();
    },
  },
  created() {
    this.getHeaders();
    this.getParams();

    /*
    Django Visitor Pass Thoughts:
    I'm not sure the visitor session is doing anything useful here?
    - Anyone with the link can access (just the advisor slug)
    - We are staying on the same page (Vue router)
    - Context data is stored on the frontend

    Maybe it's carry over from institutional questionnaire work?
    Anyway, it doesn't work when embedded because it relies on cookies.
    We need a different solution.
    I don't want to scrap it completely, just in case it's used for something.

    We are already storing the vuid in the frontend state.
    So I think the simplest solution is to:
    - If vuid is available add to url params (frontend)
    - Check for a session first (backend)
    - If not available check for the vuid in the url params (backend)
    - As an extra check confirm that request is coming from an approved url (backend)

    Dear Future Developer:
    - This is probably not the ideal solution
    - It's a compromise to get it working quickly while minimizing risk of bugs
    - If you find yourself here and there is time to develop a better, more general solution, go for it!
    */
    if (this.vuid) this.getVisitorContext();
    else {
      console.log('No vuid provided, creating a new visitor.');
      this.createNewVisitor();
    }
  },
  computed: {
    ...mapStores(useAdvisorStore),
  },
  methods: {
    getParams() {
      const params = new URL(window.location.href).searchParams;

      this.advisorSlug = params.get('advisor');
      this.vuid = params.get('vuid');
      this.advisorStore.vuid = this.vuid;
      this.prospectID = params.get('prospect');
      this.isEmbed = params.get('is_embed');
      this.vadisNonEmbed = params.get('vadis') === 'true' || params.get('vadis') === 'True';
    },
    async getProspect() {
      // This is not needed if embedded
      if (this.isEmbed) return null;
      if (!this.prospectID) return null;
      let res;
      if (this.prospectID.startsWith('shareowner')) {
        res = await fetch(`/api/v1/portfolios/${this.prospectID}/`);
        const data = await res.json();
        this.prospect = data.portfolio;
      } else {
        res = await fetch(`/api/v1/prospects/${this.prospectID}/`);
        const data = await res.json();
        this.prospect = data.prospect;
      }
    },
    async createNewVisitor() {
      let url = await this.getRedirectURL();

      url = this.addParams(url, {
        advisor: this.advisorSlug,
        prospect: this.prospectID,
        is_embed: this.isEmbed,
        vadis: this.vadisNonEmbed,
      });

      window.location.href = url;
    },
    addParams(baseURL, params) {
      const url = new URL(baseURL);

      Object.entries(params).forEach(([key, value]) => {
        if (value) {
          url.searchParams.append(key, value);
        }
      });
      return url.toString();
    },
    async getRedirectURL() {
      const body = {
        advisorSlug: this.advisorSlug,
        prospectID: this.prospectID,
        vadis: this.vadisNonEmbed,
        ...this.contactInfo,

        url: '/ui/visitor/wizard',
      };

      const res = await fetch('/api/v1/create-wizard-context/', {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify(body),
      });

      const data = await res.json();
      console.log(data);
      return data.redirect_link;
    },
    async getVisitorContext() {
      console.log('Getting visitor context');
      let url = '/api/v1/get-visitor-context';
      // Add vuid to url params if available
      // This will be used to identify the visitor session when embedded in an iframe
      if (this.vuid) url = url + `?vuid=${this.vuid}`;

      const data = await (await fetch(url)).json();
      console.log('Here is the visitor context', data);

      this.context = {
        ...data.context,
        client_id: this.prospectID,
      };
    },
    getHeaders() {
      this.headers = {
        'Content-Type': 'application/json',
        'X-CSRFToken': this.getCSRF(),
      };
    },
    getCSRF() {
      const selector = '[name="csrfmiddlewaretoken"]';
      return document.querySelector(selector)?.value;
    },
  },
};
</script>


<style scoped>

</style>
